import { render, staticRenderFns } from "./DefaultLanguageSettings.vue?vue&type=template&id=1652b060&scoped=true&"
import script from "./DefaultLanguageSettings.vue?vue&type=script&lang=js&"
export * from "./DefaultLanguageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1652b060",
  null
  
)

export default component.exports